import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const Legend = styled(Row)`
  padding-top: ${({ theme }) => theme.x2spacePx}px;
  ${media.smUp`
    padding-left: ${({ theme }) => theme.x7spacePx}px;
  `}
  button {
    display: block;
  }
`;

export const Dot = styled('svg')`
  margin-right: ${({ theme }) => theme.x1spacePx}px;
`;

export const TooltipTitle = styled('div')`
  max-width: 200px;
`;
